import * as api from '../api/codefile';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'QUEUE';

export const FETCH_CODEFILE_CONFIG_START = `${namespace}/FETCH_CODEFILE_CONFIG_START`;
export const FETCH_CODEFILE_CONFIG_SUCCESS = `${namespace}/FETCH_CODEFILE_CONFIG_SUCCESS`;
export const FETCH_CODEFILE_CONFIG_ERROR = `${namespace}/FETCH_CODEFILE_CONFIG_ERROR`;

export const FETCH_DETAIL_CODEFILES_START = `${namespace}/FETCH_DETAIL_CODEFILES_START`;
export const FETCH_DETAIL_CODEFILES_SUCCESS = `${namespace}/FETCH_DETAIL_CODEFILES_SUCCESS`;
export const FETCH_DETAIL_CODEFILES_ERROR = `${namespace}/FETCH_DETAIL_CODEFILES_ERROR`;

export const FETCH_SUMMARY_CODEFILES_START = `${namespace}/FETCH_SUMMARY_CODEFILES_START`;
export const FETCH_SUMMARY_CODEFILES_SUCCESS = `${namespace}/FETCH_SUMMARY_CODEFILES_SUCCESS`;
export const FETCH_SUMMARY_CODEFILES_ERROR = `${namespace}/FETCH_SUMMARY_CODEFILES_ERROR`;

export const INSERT_CODEFILE_START = `${namespace}/INSERT_CODEFILE_START`;
export const INSERT_CODEFILE_SUCCESS = `${namespace}/INSERT_CODEFILE_SUCCESS`;
export const INSERT_CODEFILE_ERROR = `${namespace}/INSERT_CODEFILE_ERROR`;

export const UPDATE_CODEFILE_START = `${namespace}/UPDATE_CODEFILE_START`;
export const UPDATE_CODEFILE_SUCCESS = `${namespace}/UPDATE_CODEFILE_SUCCESS`;
export const UPDATE_CODEFILE_ERROR = `${namespace}/UPDATE_CODEFILE_ERROR`;

export const DELETE_CODEFILE_START = `${namespace}/DELETE_CODEFILE_START`;
export const DELETE_CODEFILE_SUCCESS = `${namespace}/DELETE_CODEFILE_SUCCESS`;
export const DELETE_CODEFILE_ERROR = `${namespace}/DELETE_CODEFILE_ERROR`;
export const CHANGE_DETAIL_PAGE = `${namespace}/CHANGE_DETAIL_PAGE`;
export const CHANGE_DETAIL_SORT_MODEL = `${namespace}/CHANGE_DETAIL_SORT_MODEL`;
export const CHANGE_DETAIL_FILTER_MODEL = `${namespace}/CHANGE_DETAIL_FILTER_MODEL`;

export const CHANGE_SUMMARY_PAGE = `${namespace}/CHANGE_SUMMARY_PAGE`;
export const CHANGE_SUMMARY_SORT_MODEL = `${namespace}/CHANGE_SUMMARY_SORT_MODEL`;
export const CHANGE_SUMMARY_FILTER_MODEL = `${namespace}/CHANGE_SUMMARY_FILTER_MODEL`;

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const fetchCodefileConfig = makeApiActionCreatorV3(
  api.fetchCodefileConfig,
  FETCH_CODEFILE_CONFIG_START,
  FETCH_CODEFILE_CONFIG_SUCCESS,
  FETCH_CODEFILE_CONFIG_ERROR,
);

export const fetchDetailCodefiles = makeApiActionCreatorV3(
  api.fetchDetailCodefiles,
  FETCH_DETAIL_CODEFILES_START,
  FETCH_DETAIL_CODEFILES_SUCCESS,
  FETCH_DETAIL_CODEFILES_ERROR,
);

export const fetchSummaryCodefiles = makeApiActionCreatorV3(
  api.fetchSummaryCodefiles,
  FETCH_SUMMARY_CODEFILES_START,
  FETCH_SUMMARY_CODEFILES_SUCCESS,
  FETCH_SUMMARY_CODEFILES_ERROR,
);

export const insertCodefile = makeApiActionCreatorV3(
  api.insertCodefile,
  INSERT_CODEFILE_START,
  INSERT_CODEFILE_SUCCESS,
  INSERT_CODEFILE_ERROR,
);

export const updateCodefile = makeApiActionCreatorV3(
  api.updateCodefile,
  UPDATE_CODEFILE_START,
  UPDATE_CODEFILE_SUCCESS,
  UPDATE_CODEFILE_ERROR,
);

export const deleteCodefile = makeApiActionCreatorV3(
  api.deleteCodefile,
  DELETE_CODEFILE_START,
  DELETE_CODEFILE_SUCCESS,
  DELETE_CODEFILE_ERROR,
);
export const changeDetailPage = page => ({
  type: CHANGE_DETAIL_PAGE,
  payload: page,
});

export const changeSummaryPage = page => ({
  type: CHANGE_SUMMARY_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const changeDetailSortModel = sortModel => ({
  type: CHANGE_DETAIL_SORT_MODEL,
  payload: sortModel,
});

export const changeSummarySortModel = sortModel => ({
  type: CHANGE_SUMMARY_SORT_MODEL,
  payload: sortModel,
});

export const changeDetailFilterModel = model => ({
  type: CHANGE_DETAIL_FILTER_MODEL,
  payload: model,
});

export const changeSummaryFilterModel = model => ({
  type: CHANGE_SUMMARY_FILTER_MODEL,
  payload: model,
});
